/**
 * Tool Item Tokens
 */

import { accent, corners, space, glass, shadow as shadowTokens } from "../semantic";

export const toolItem = {
  // Glass effect base
  bg: glass.bg,
  bgPressed: glass.bgPressed,
  bgForced: glass.bgForced,
  backdropFilter: glass.backdrop,
  height: "44px",
  paddingX: space.insetMd,
  gap: space.insetSm,
  radius: corners.card,
  // Glass borders
  border: `1px solid ${glass.border}`,
  borderForced: `1px solid ${glass.borderForced}`,
  // Glass shadows
  shadow: shadowTokens.glass,
  shadowForced: shadowTokens.glassForced,
  glowForced: `0 0 ${space.insetMd} ${accent.forcedMuted}`,
  icon: { size: "32px", radius: corners.button, bgDefault: glass.iconBg, bgForced: glass.iconBgForced },
} as const;
